module.exports = __webpack_public_path__ + "static/media/content_providers.33479bb9.png";